import Permissions from "../../models/Permissions";

const Produtos = () => import("./Index.vue");

const permissions = [
  Permissions.COLABORADOR,
  Permissions.GESTOR,
  Permissions.ADMINISTRADOR,
];

const meta = {
  requiresAuth: true,
  requiresCompany: true,
  showInMenu: true,
  label: "Sped Tabelas",
  icon: "fa fa-file",
  // group: 'ICMS',
  group: "Arquivos",
  permissions,
};

export default [
  {
    path: "/produtos",
    name: "Produtos",
    component: Produtos,
    meta,
  },
];
